<template>
    <cic-popup
        :title="item.profileId ? 'Edit Retry Profile' : 'New Retry Profile'"
        :saveable="true"
        class="edit-retry-profile"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <h3 v-if="item.profileId" style="padding-left: 6px">{{ item.name }}</h3>
        <div class="item-form">
            <ul>
                <template v-if="!item.profileId">
                    <li class="form-label-first">
                        {{ $t('Name') }}
                    </li>
                    <li>
                        <cic-textbox
                            id="profile_name"
                            :value="item.name"
                            :maxlength="256"
                            @input="(val) => updateFieldValue('name', val)"
                        />
                    </li>
                </template>
                <li class="form-label">
                    {{ $t('Number of call attempts') }}
                </li>
                <li>
                    <cic-textbox
                        id="profile_max_attempts"
                        :value="item.maxAttempts"
                        :maxlength="10"
                        :int-only="true"
                        @input="(val) => updateFieldValue('maxAttempts', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Number of call attempts per day') }}
                </li>
                <li>
                    <cic-textbox
                        id="profile_max_attempt_daily"
                        :value="item.maxAttemptsDaily"
                        :maxlength="10"
                        :int-only="true"
                        @input="(val) => updateFieldValue('maxAttemptsDaily', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Number of call attempts per number') }}
                </li>
                <li>
                    <cic-textbox
                        id="profile_max_attempt_number"
                        :value="item.maxAttemptsPerNumber"
                        :maxlength="10"
                        :int-only="true"
                        :disabled="item.unlimitedAttemptsPerNumber"
                        @input="(val) => updateFieldValue('maxAttemptsPerNumber', val)"
                    />
                    <span>{{ $t('Unlimited') }}</span>
                    <cic-checkbox
                        id="profile_unlimited_attempts"
                        :value="item.unlimitedAttemptsPerNumber"
                        @input="(val) => updateFieldValue('unlimitedAttemptsPerNumber', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Retry calls between') }}
                </li>
                <li>
                    <cic-time-picker
                        id="profile_start"
                        :value="item.startTime"
                        :clearable="false"
                        format="HH:mm"
                        @input="(val) => updateFieldValue('startTime', val)"
                    />
                    <span>{{ $t('and') }}</span>
                    <cic-time-picker
                        id="profile_end"
                        :value="item.endTime"
                        :clearable="false"
                        format="HH:mm"
                        @input="(val) => updateFieldValue('endTime', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Retry completion codes') }}
                </li>
                <li>
                    <edit-completion-codes
                        id="retryCodesList"
                        :codes="item.completionCodes"
                        :parameters="parameters"
                        @input="(val) => updateFieldValue('completionCodes', val)"
                    />
                </li>
                <template v-if="failCodes">
                    <li class="form-label">
                        {{ $t('Call Failure completion codes') }}
                    </li>
                    <li>
                        <div v-if="immediateDial" class="td-label immediateDialNextOnFailure">
                            <span>{{ $t('Immediately dial the next available number on call failure') }}</span>
                            <cic-checkbox
                                :value="item.immediateDialNextOnFailure"
                                @input="(val) => updateFieldValue('immediateDialNextOnFailure', val)"
                            />
                        </div>
                        <edit-completion-codes
                            :codes="item.failureCompletionCodes"
                            :failure="true"
                            :parameters="parameters"
                            @input="(val) => updateFieldValue('failureCompletionCodes', val)"
                        />
                    </li>
                </template>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import CicTimePicker from '@/components/inputs/CicTimePicker';
    import EditCompletionCodes from './EditCompletionCodes';

    export default {
        name: 'EditRetryProfile',
        components: {
            EditCompletionCodes,
            CicCheckbox,
            CicPopup,
            CicTextbox,
            CicTimePicker,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            parameters: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        computed: {
            failCodes() {
                return (
                    !Object.keys(this.parameters).includes('REDDIAL_RETRY_PROFILE_CALL_FAILURE_CODES') ||
                    this.parameters.REDDIAL_RETRY_PROFILE_CALL_FAILURE_CODES === '1'
                );
            },
            immediateDial() {
                return !!(
                    this.parameters.DialEnableImmediateDialNextOnFailure &&
                    this.parameters.DialEnableImmediateDialNextOnFailure === '1'
                );
            },
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('updateFieldValue', field, val);
            },
        },
    };
</script>
